import {
  GET_EMPRESAS,
  GET_EMPRESA,
  EMPRESAS_ERROR
} from '../actions/types';

const initialState = {
  empresas: [],
  empresa: null,
  loading: true,
  error: {}
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_EMPRESAS:
      return {
        ...state,
        empresas: payload,
        loading: false
      };
    case GET_EMPRESA:
      return {
        ...state,
        empresa: payload,
        loading: false
      };
    case EMPRESAS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
